import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooutstationurbaniaonrent() {



    const cardData =
    {
        keyword: 'Pune to Outstation Urbania on Rent',
        heading: 'Urbania on rent in pune: Pune to Outstation Urbania on Rent',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Outstation Urbania on Rent services for families, corporate groups, tourists, and event travelers planning comfortable long-distance travel. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, ample luggage space, and smooth highway performance, making it ideal for weekend getaways, corporate trips, weddings, pilgrimages, sightseeing tours, and intercity journeys from Pune. With professional chauffeurs experienced on outstation routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to outstation Urbania hire.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Pune to Outstation Urbania on Rent",
"description": "Pune to Outstation Urbania on Rent provides reliable and comfortable Urbania buses for long-distance travel from Pune to various outstation destinations. The service is ideal for families, corporate groups, and tourists who require safe and smooth transportation over extended routes. With spacious seating, clean and well-maintained interiors, ample luggage space, and experienced drivers familiar with highways and intercity routes, travelers can enjoy a relaxed and stress-free journey. Both AC and non-AC options are available, ensuring comfort in all weather conditions."
},
{
"name": "Outstation Urbania Hire Pune",
"description": "Outstation Urbania Hire Pune offers flexible bus rental solutions for one-way and round-trip travel from Pune to outstation locations. The service focuses on punctual pickups, professional chauffeurs, and reliable vehicles that are regularly serviced for long-distance performance. Passengers benefit from comfortable seating, safety features, and smooth ride quality, making it suitable for leisure trips, pilgrimages, and business travel. Families and large groups can travel together conveniently without the hassle of multiple vehicles."
},
{
"name": "Urbania Bus Rental for Outstation Pune",
"description": "Urbania Bus Rental for Outstation Pune provides well-maintained Urbania buses designed specifically for long highway journeys. These buses feature spacious legroom, clean interiors, and ample luggage capacity to support extended travel plans. Experienced drivers ensure safe driving practices and timely arrivals at destinations. The service is ideal for group tours, corporate travel, and family vacations, offering dependable transportation with comfort and peace of mind."
},
{
"name": "Urbania AC Outstation Bus Pune",
"description": "Urbania AC Outstation Bus Pune offers fully air-conditioned Urbania buses to ensure a comfortable and climate-controlled journey during long-distance travel. The AC buses are equipped with comfortable seating and clean interiors, making them suitable for summer travel and extended routes. Professional chauffeurs handle the driving with care and expertise, allowing passengers to relax and enjoy a smooth ride throughout the outstation journey."
},
{
"name": "Pune Outstation Urbania One Way Hire",
"description": "Pune Outstation Urbania One Way Hire provides convenient one-way travel options for passengers traveling from Pune to outstation destinations. This service is ideal for travelers who do not require a return trip, offering cost-effective and flexible rental solutions. With reliable vehicles, professional drivers, and comfortable seating, passengers can enjoy a safe and hassle-free one-way journey."
},
{
"name": "Pune Outstation Urbania Round Trip Hire",
"description": "Pune Outstation Urbania Round Trip Hire offers complete round-trip transportation solutions for outstation travel. The service includes well-planned travel schedules, ensuring timely departures and returns. Passengers can rely on comfortable Urbania buses, experienced chauffeurs, and dependable service throughout the journey, making it ideal for holidays, pilgrimages, and extended family or group trips."
},
{
"name": "Corporate Outstation Urbania Pune",
"description": "Corporate Outstation Urbania Pune provides professional transport services for corporate teams traveling to outstation locations. The service emphasizes punctuality, comfort, and efficient coordination, ensuring employees and executives travel together safely. With clean interiors, comfortable seating, and trained drivers, it supports smooth business travel, corporate events, and official tours."
},
{
"name": "Family Outstation Urbania Pune",
"description": "Family Outstation Urbania Pune is designed to offer a safe and comfortable travel experience for families traveling to outstation destinations. The buses provide spacious seating, clean interiors, and a smooth ride, making long journeys enjoyable for all age groups. Experienced drivers ensure careful driving and timely arrivals, allowing families to travel together comfortably."
},
{
"name": "Luxury Outstation Urbania Pune",
"description": "Luxury Outstation Urbania Pune delivers a premium travel experience with modern interiors, plush seating, and superior comfort for long-distance journeys. Ideal for travelers who prefer luxury and style, these buses offer a refined atmosphere along with professional chauffeur services. This option is suitable for VIP travel, special occasions, and high-end group tours."
},
{
"name": "Affordable Outstation Urbania Pune",
"description": "Affordable Outstation Urbania Pune provides budget-friendly bus rental options for outstation travel without compromising on safety or comfort. The service offers well-maintained buses, professional drivers, and reliable performance, making it suitable for cost-conscious families and group travelers planning long-distance trips."
},
{
"name": "Chauffeur Driven Outstation Urbania Pune",
"description": "Chauffeur Driven Outstation Urbania Pune ensures a stress-free travel experience with trained, verified drivers who are experienced in long-distance and interstate routes. Passengers can relax and enjoy the journey while the chauffeurs handle navigation, traffic, and safety. The service is ideal for families, corporate groups, and tourists seeking worry-free outstation travel."
},
{
"name": "Best Outstation Urbania Rental Pune",
"description": "Best Outstation Urbania Rental Pune is known for high-quality vehicles, professional service, and consistent reliability. The buses are spacious, clean, and well-equipped for long journeys, offering both AC and non-AC options. This service is a preferred choice for travelers seeking dependable and comfortable outstation transportation from Pune."
},
{
"name": "Long Distance Urbania Hire Pune",
"description": "Long Distance Urbania Hire Pune specializes in extended interstate and long-route travel, providing comfortable buses, experienced drivers, and well-managed schedules. The service ensures smooth and safe travel over long distances, making it ideal for tours, pilgrimages, and multi-day travel plans."
},
{
"name": "Trusted Outstation Urbania Service Pune",
"description": "Trusted Outstation Urbania Service Pune delivers dependable and customer-focused bus rental services for outstation travel. With a strong emphasis on safety, punctuality, and vehicle quality, the service ensures a comfortable and reliable journey for families, groups, and corporate travelers."
},
{
"name": "Group Travel Outstation Urbania Pune",
"description": "Group Travel Outstation Urbania Pune offers spacious and well-coordinated transportation solutions for large groups traveling to outstation destinations. The service ensures everyone travels together comfortably, with ample seating, luggage space, and professional drivers managing the journey efficiently from start to finish."
}
],
"tableData": [
["Pune to Outstation Urbania on Rent", "Outstation Urbania Hire Pune"],
["Urbania Bus Rental for Outstation Pune", "Urbania AC Outstation Bus Pune"],
["Pune Outstation Urbania One Way Hire", "Pune Outstation Urbania Round Trip Hire"],
["Corporate Outstation Urbania Pune", "Family Outstation Urbania Pune"],
["Luxury Outstation Urbania Pune", "Affordable Outstation Urbania Pune"],
["Chauffeur Driven Outstation Urbania Pune", "Best Outstation Urbania Rental Pune"],
["Long Distance Urbania Hire Pune", "Trusted Outstation Urbania Service Pune"],
["Group Travel Outstation Urbania Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Outstation Urbania on Rent for Comfortable Travel",
        "WhyChoosedescription": "Pune to Outstation Urbania on Rent is perfect for long-distance trips, family vacations, group outings, corporate tours, and leisure journeys, offering a comfortable and hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to outstation travel come with air-conditioning, comfortable reclining seats, ample legroom, and plenty of luggage space to make your journey relaxing."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Outstation Routes",
        "WhyChoosedescription": "All drivers are licensed, trained, and experienced in handling Pune to outstation routes, ensuring safe, punctual, and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Outstation Urbania on Rent offers competitive pricing with no hidden charges, making long-distance travel cost-effective and convenient."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for one-way trips, round trips, multi-day tours, family outings, and customized travel plans based on your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and safety throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Outstation Urbania on Rent service guarantees on-time departures, dependable travel support, and a smooth overall experience."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Outstation Urbania on Rent be booked for long-distance travel?',
        answer: 'Yes, it is suitable for long-distance trips, family vacations, group outings, corporate tours, and interstate travel.'
    },
    {
        question: 'How can I book Pune to Outstation Urbania on Rent?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Outstation Urbania on Rent?',
        answer: 'This service offers comfortable seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are the drivers experienced for outstation routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with popular outstation destinations from Pune.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off points are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Outstation Urbania on Rent available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your trip.'
    },
    {
        question: 'Is this service suitable for families and large groups?',
        answer: 'Yes, Pune to Outstation Urbania on Rent is ideal for families, groups, and corporate travelers.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manoj Kulkarni',
        feedback: 'We booked an Urbania bus from Pune for an outstation trip. The bus was spacious and comfortable, and the journey was smooth and enjoyable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Shruti Patil',
        feedback: 'Professional service with a friendly driver. Pune to Outstation Urbania on Rent made our long-distance trip stress-free and pleasant.',
        rating: 5
    }
];















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Urbania on Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-outstation-urbania.jpg",
  "description": "Pune to Outstation Urbania on Rent offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, long-distance journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to outstation destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-outstation-urbania-on-rent"
  }
};











    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Outstation Urbania on Rent | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Outstation Urbania on Rent for one-way or round-trip travel, corporate trips, family tours, long-distance journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to outstation destinations."
  />

  <meta
    name="keywords"
    content="Pune to Outstation Urbania on Rent, Outstation Urbania Hire Pune, Urbania Bus Rental for Outstation Pune, Urbania AC Outstation Bus Pune, Pune Outstation Urbania One Way Hire, Pune Outstation Urbania Round Trip Hire, Corporate Outstation Urbania Pune, Family Outstation Urbania Pune, Luxury Outstation Urbania Pune, Affordable Outstation Urbania Pune, Chauffeur Driven Outstation Urbania Pune, Best Outstation Urbania Rental Pune, Long Distance Urbania Hire Pune, Trusted Outstation Urbania Service Pune, Group Travel Outstation Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/111.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetooutstationurbaniaonrent;